export const formName = 'doc-membership-details-form';

export enum DOCMembershipOrganizationDetailsFormFields {
  Organization = 'organization',
  SubscriptionType = 'subscriptionType',
  PackageType = 'packageType',
  EffectiveDate = 'effectiveDate',
  ExpirationDate = 'expirationDate',
}
